var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedVisiblity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5618_168133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8806 7.454C15.2952 6.174 12.9999 2 7.99992 2C2.99991 2 0.704581 6.174 0.119248 7.454C0.040673 7.62553 0 7.81199 0 8.00067C0 8.18934 0.040673 8.3758 0.119248 8.54733C0.704581 9.826 2.99991 14 7.99992 14C12.9999 14 15.2952 9.826 15.8806 8.546C15.959 8.37466 15.9996 8.18843 15.9996 8C15.9996 7.81157 15.959 7.62534 15.8806 7.454V7.454ZM7.99992 12.6667C3.79525 12.6667 1.83325 9.08933 1.33325 8.00733C1.83325 6.91067 3.79525 3.33333 7.99992 3.33333C12.1946 3.33333 14.1572 6.89533 14.6666 8C14.1572 9.10467 12.1946 12.6667 7.99992 12.6667Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 4.66699C7.34203 4.66699 6.69757 4.86249 6.1494 5.22876C5.60124 5.59503 5.174 6.11563 4.92171 6.72471C4.66941 7.3338 4.6034 8.00402 4.73202 8.65063C4.86064 9.29723 5.17811 9.89117 5.64428 10.3573C6.11046 10.8235 6.7044 11.141 7.351 11.2696C7.99761 11.3982 8.66783 11.3322 9.27692 11.0799C9.886 10.8276 10.4066 10.4004 10.7729 9.85223C11.1391 9.30406 11.3346 8.6596 11.3346 8.00033C11.3336 7.1166 10.982 6.26936 10.3572 5.64447C9.73226 5.01958 8.88503 4.66805 8.0013 4.66699V4.66699ZM8.0013 10.0003C7.60574 10.0003 7.21906 9.88303 6.89016 9.66326C6.56126 9.4435 6.30492 9.13114 6.15354 8.76569C6.00217 8.40024 5.96256 7.99811 6.03973 7.61015C6.1169 7.22218 6.30738 6.86582 6.58709 6.58611C6.86679 6.30641 7.22316 6.11593 7.61112 6.03875C7.99909 5.96158 8.40122 6.00119 8.76667 6.15257C9.13212 6.30394 9.44448 6.56029 9.66424 6.88919C9.88401 7.21808 10.0013 7.60476 10.0013 8.00033C10.0013 8.53076 9.79059 9.03947 9.41552 9.41454C9.04044 9.78961 8.53174 10.0003 8.0013 10.0003Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5618_168133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedVisiblity);
export default __webpack_public_path__ + "static/media/outlinedVisiblity.385258a954b60a81ec006f7649d1cb87.svg";
export { ForwardRef as ReactComponent };